import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDataCatalogLineageWorkbookActive = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="data-catalog-lineage-workbook-active_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>{".data-catalog-lineage-workbook-active_svg__st0{fill:#333}"}</style>
    <path
      id="data-catalog-lineage-workbook-active_svg__Line_3_"
      className="data-catalog-lineage-workbook-active_svg__st0"
      d="M7 16h9v1H7z"
    />
    <path
      id="data-catalog-lineage-workbook-active_svg__Bar3_6_"
      className="data-catalog-lineage-workbook-active_svg__st0"
      d="M14 10h1v5h-1z"
    />
    <path
      id="data-catalog-lineage-workbook-active_svg__Bar2_6_"
      className="data-catalog-lineage-workbook-active_svg__st0"
      d="M11 9h1v6h-1z"
    />
    <path
      id="data-catalog-lineage-workbook-active_svg__Bar1_6_"
      className="data-catalog-lineage-workbook-active_svg__st0"
      d="M8 11h1v4H8z"
    />
    <path
      id="data-catalog-lineage-workbook-active_svg__NotebookOutline_3_"
      className="data-catalog-lineage-workbook-active_svg__st0"
      d="M20 10V7h-1V6c0-.5-.5-1-1-1H5c-.5 0-1 .5-1 1v13c0 .5.5 1 1 1h13c.5 0 1-.5 1-1v-1h1v-3h-1v-1h1v-3h-1v-1h1zm-2 9H5V6h13v13z"
    />
  </svg>
);
const Memo = memo(SvgDataCatalogLineageWorkbookActive);
export default Memo;
